// File Metadata:
// Filename: PersistLogin.js
// Version: 1.00
// Created: 2022-09-28 21:44:15
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { useRefreshMutation } from '../api/authApiSlice';
import { selectCurrentToken, selectCurrentUser, setCredentials } from './authSlice';
import usePersist from '../../hooks/usePersist';
import { tokenService } from '../../services/tokenService'; // Import tokenService

const PersistLogin = () => {
    const [persist] = usePersist();
    const dispatch = useDispatch();
    const token = useSelector(selectCurrentToken);
    const user = useSelector(selectCurrentUser);
    const [isLoading, setIsLoading] = useState(true);
    const [refresh] = useRefreshMutation();

    useEffect(() => {
        const verifyAuth = async () => {
            try {
                // If we have a token but no user, try refresh
                if (token && !user) {
                    console.log('Token exists but no user, refreshing...');
                    const { data } = await refresh().unwrap();
                    dispatch(setCredentials(data));
                }
                // If no token but persist enabled, try refresh
                else if (!token && persist) {
                    console.log('No token, attempting refresh...');
                    const { data } = await refresh().unwrap();
                    dispatch(setCredentials(data));
                }
            } catch (err) {
                console.error('Auth verification failed:', err);
                tokenService.clearTokens();
            } finally {
                setIsLoading(false);
            }
        };

        verifyAuth();
    }, []);

    if (isLoading) return <div>Loading...</div>;
    return <Outlet />;
};

export default PersistLogin;